export default {
  en: {
    title: 'Цифровые блокчейн паспорта для продукции ИСП "Заря"',
    menu: {
      main: "главная"
    },
    main: {
      title: 'Цифровые блокчейн паспорта для продукции ИСП "Заря"',
      view: "Подробнее",
      prev: "Назад",
      next: "Далее"
    },
    details: {
      title: "Просмотр блокчейн паспорта"
    }
  },
  ru: {
    title: 'Цифровые блокчейн паспорта для продукции ИСП "Заря"',
    menu: {
      main: "главная"
    },
    main: {
      title: 'Цифровые блокчейн паспорта для продукции ИСП "Заря"',
      view: "Подробнее",
      prev: "Назад",
      next: "Далее"
    },
    details: {
      title: "Просмотр блокчейн паспорта"
    }
  }
};
